import { MapClockOutlineIcon } from './MapClockOutlineIcon';

/**
 * author: Augustin Ursu
 * id EEB984B2-6639-452D-AD56-06A8EC862EE4
 * name map-clock-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-clock-outline.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 * - Date / Time 
 */
export const TimezoneOutlineIcon = MapClockOutlineIcon;
export default TimezoneOutlineIcon